import calendar from '@/utils/clinic-calendar'

// L'ancienne API exposait aussi une date lisible, mais sans fuseau : elle était produite en UTC.
const instantHistorique = valeur => {
    const match = typeof valeur === 'string' && valeur.match(/^(\d{2})-(\d{2})-(\d{4}) à (\d{2}):(\d{2})$/)
    if (!match) return null
    const source = `${match[3]}-${match[2]}-${match[1]}T${match[4]}:${match[5]}:00Z`
    const date = calendar.instant(source)
    return date && date.toISOString().slice(0, 16) === source.slice(0, 16) ? source : null
}

export const fuseauStock = store => calendar.timezone(
    store && store.getters && store.getters.config_info_clinique && store.getters.config_info_clinique.fuseau_horaire
)

export const chargerFuseauStock = async store => {
    if (store && store.dispatch && !(store.getters && store.getters.config_info_clinique && store.getters.config_info_clinique.fuseau_horaire)) {
        try { await store.dispatch('getConfigInfoClinique', 'info_clinique') } catch (error) { /* UTC reste affiché explicitement. */ }
    }
}

export const dateStock = (evenement, fuseau) => {
    if (!evenement) return ''
    const instant = evenement.date_utc || evenement.created_at || instantHistorique(evenement.date)
    const date = calendar.parts(instant, fuseau)
    return date ? `${date.day}/${date.month}/${date.year} à ${date.hour}:${date.minute}` : ''
}
